import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import LoginForm from 'components/organisms/LoginForm'
import TransitionPage from 'containers/TransitionPage'

export const styles = theme => ({
  root: {
    width: 328,
    margin: '0 auto',
    position: 'relative',
    ...theme.components.accountPage,
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
})

const Login = ({ classes, hasError, onLoginSubmit }) => (
  <TransitionPage>
    <div className={classes.root}>
      <Typography variant="h1" className={classes.title}>
        Sign in to <br />
        Goodnature
      </Typography>
      <LoginForm onLogin={onLoginSubmit} apiCallError={hasError} showActions />
    </div>
  </TransitionPage>
)

Login.propTypes = {
  hasError: PropTypes.bool,
  onLoginSubmit: PropTypes.func,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Login)



// WEBPACK FOOTER //
// ./src/containers/account/Login/Login.js